import React, {useEffect, useState} from "react";
import {Label} from 'react-aria-components';
import {useParams} from "react-router-dom";
import {LuCog, LuMousePointerClick} from "react-icons/lu";

import FullWidthLayout from "../../layouts/FullWidthLayout/FullWidthLayout";
import api from "../../utils/api";
import {LabeledSection} from "../../components/Fields/LabeledTextField";
import DefaultButton, {SecondaryButton} from "../../components/Buttons/DefaultButton/DefaultButton";
import ConfirmationModal from "../../components/ConfirmationModal/ConfirmationModal";
import "./UserEdit.css";
import LoadingLayout from "../../layouts/LoadingLayout/LoadingLayout";


function UserEdit() {
    const {id} = useParams();
    const [user, setUser] = useState(null)
    const [currentUser, setCurrentUser] = React.useState(null);
    const [showPermissionEdit, setShowPermissionEdit] = React.useState(false)
    const [showResendInvite, setShowResendInvite] = React.useState(false)


    function changePermission() {
        api.updateOrganizationOwner(id).then((data) => {
            setUser(data)
        })
        setShowPermissionEdit(false)
    }

    function onCancelPermissionEdit() {
        setShowPermissionEdit(false)
    }

    function resendInvite() {
        api.inviteUser({
            recipient: user.email
        }).then(() => {
            setShowResendInvite(false)
        })
    }

    function onCancelResendInvite() {
        setShowResendInvite(false)
    }


    useEffect(() => {
        api.getUser(id).then((data) => {
            setUser(data)
        })
        api.getCurrentUser().then((data) =>{
            setCurrentUser(data)
        })
    }, []);
    
    if (!user || !currentUser) {
        return <LoadingLayout />
    }

    let permissionEditModal = null
    if (showPermissionEdit) {
        permissionEditModal = <ConfirmationModal
            title="Transfer Ownership"
            message={`Are you sure you want to transfer ownership of the organization from ${currentUser.email} to ${user.email}?`}
            onConfirm={changePermission}
            onCancel={onCancelPermissionEdit}
        />
    }

    let resendInviteModal = null
    if (showResendInvite) {
        resendInviteModal = <ConfirmationModal
            title="Resend Invitation"
            message={`Are you sure you want to resend the invitation to ${user.email}?`}
            onConfirm={resendInvite}
            onCancel={onCancelResendInvite}
        />
    }

    const content = <div id="user-edit">
        {permissionEditModal}
        {resendInviteModal}
        <LabeledSection label="General" icon={<LuCog/>} className="general-settings">
            <table className="user-general-settings">
                <tbody>
                    <tr>
                        <td className="key"><Label>Email:</Label></td>
                        <td className="val">{user.email}</td>
                    </tr>
                    <tr>
                        <td className="key"><Label>Permission Level:</Label></td>
                        <td className="val">{user.permissionLevel}</td>
                    </tr>
                </tbody>
            </table>
        </LabeledSection>
        <LabeledSection label="Actions" icon={<LuMousePointerClick/>} className="action-buttons">
            {user.permissionLevel !== "owner" && currentUser.permissionLevel === "owner" ?
                    <DefaultButton
                        text="Transfer Ownership"
                        className="permission-edit-button"
                        onPress={() => {
                            setShowPermissionEdit(true)
                        }}
                        oneClick />
                : null}
            <DefaultButton
                text="Resend Invitation Email"
                className="resend-invite-button"
                onPress={() => {
                    setShowResendInvite(true)
                }}
                oneClick />
        </LabeledSection>

        <div className="save-row">
            <SecondaryButton
                className="return-button"
                text="Return"
                href="/organization_users" />
        </div>
    </div>

    return <FullWidthLayout
        title={"Edit Organization User"}
        mainContent={content}
    />
}

export default UserEdit
